<template>
  <ion-page ref="thisPage">
    <page-header title="Mis pedidos"/>
    <ion-content>

      <!-- START: Customer Orders List-->
      <ion-list lines="full" v-if="orders.length">
        <ion-item button v-for="order in orders" :key="order.id" @click="openOrderModal(order)">
          <ion-label slot="start" class="ion-padding-vertical">
            <ion-badge :class="'order-status--' + order.status">{{ orderStatuses[order.status] }}</ion-badge>
            <h2>Pedido #{{ order.id }}</h2>
            <h3 style="color: var(--ion-color-dark); font-size: 0.7em">
              {{ $day(order.date_created).format("D [de] MMMM [de] YYYY").toLowerCase() }}</h3>
          </ion-label>
          <ion-label class="ion-text-right">
            <h3>{{ $currency(order.total) }}</h3>
            <p>{{ order.line_items.length }} productos</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <!-- END: Customer Orders List-->


      <!-- START: Skeleton Text (loading stage)-->
      <ion-list lines="full" v-else>
        <ion-item v-for="i in 7" :key="i" :detail="true">
          <ion-label slot="start" class="ion-padding-vertical ion-no-margin">
            <ion-skeleton-text animated style="width: 55%; height: 19px; --border-radius: 10px; margin-top: 0"/>
            <ion-skeleton-text animated style="width: 70%; height: 21px; margin: 0 0 4px 0"/>
            <ion-skeleton-text animated style="width: 90%; height: 15px; margin: 0"/>
          </ion-label>
          <ion-label class="ion-text-right">
            <h3>
              <ion-skeleton-text class="ion-float-right" animated style="width: 30%; height: 17px; margin: 0"/>
            </h3>
            <p>
              <ion-skeleton-text class="ion-float-right" animated style="width: 50%; height: 15px; margin: 0"/>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
      <!-- END: Skeleton Text (loading stage)-->


      <ion-infinite-scroll id="orders-scroll" threshold="100px"
                           :disabled="isDisabled" @ionInfinite="loadData($event)">
        <ion-infinite-scroll-content class="ion-margin-vertical"
                                     loading-spinner="crescent"
                                     loading-text="Cargando tus pedidos..."/>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonPage,
  IonContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
  IonItem,
  IonBadge,
  IonSkeletonText,
  IonLabel, modalController
} from '@ionic/vue';
import PageHeader from '@/components/PageStructure/PageHeader.vue';
import OrderModal from "@/components/Modals/OrderModal.vue";
import { OrderType } from "@/interfaces/types";
import { orderStatuses } from "@/config/StaticStrings";
import { defineComponent, ref } from "vue";
import { getStoreOrders } from "@/services/Api";
import authModule from '@/store/modules/auth';

export default defineComponent({
  name: 'CustomerOrders',
  components: {
    PageHeader,
    IonPage,
    IonContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonList,
    IonItem,
    IonBadge,
    IonSkeletonText,
    IonLabel
  },
  methods: {
    async openOrderModal(order: any) {
      const thisPageRef: any = this.$refs.thisPage;
      const presentingElement: HTMLElement = thisPageRef.$el;

      const modal = await modalController
        .create({
          component: OrderModal,
          swipeToClose: true,
          presentingElement: presentingElement,
          componentProps: {
            order,
          },
        })
      return modal.present();
    },
  },
  setup() {
    let page = 1;
    let totalPages = 1;

    const customerId = authModule.loggedUserId;
    const isDisabled = ref(false);
    const orders = ref([] as OrderType[]);

    function processPostData(response: { orders: OrderType[]; totalPages: number }) {
      totalPages = +response.totalPages; // unary (+) operator casts the string to a number
      orders.value.push(...response.orders);
      isDisabled.value = page === totalPages;
    }

    const getOrders = (customerId: number, page: number, ev?: any) => {
      getStoreOrders(customerId, page).then((storeOrdersResponse) => {
        processPostData(storeOrdersResponse);
        if (ev) {
          ev.target.complete();
        }
      });
    }

    const loadData = (ev: any) => {
      page++;
      getOrders(customerId, page, ev);
    }

    getOrders(customerId, page);

    return {
      orders,
      isDisabled,
      loadData,
      orderStatuses,
    }
  },
})
</script>
